import { render, staticRenderFns } from "./EPGList.vue?vue&type=template&id=2f9fc636&scoped=true&"
import script from "./EPGList.vue?vue&type=script&lang=js&"
export * from "./EPGList.vue?vue&type=script&lang=js&"
import style0 from "./EPGList.vue?vue&type=style&index=0&id=2f9fc636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9fc636",
  null
  
)

export default component.exports